import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { string, bool, func, shape, object } from 'prop-types';
import { translate } from 'react-i18next';

import { PrivacyAndTermsDialog } from '@snapask/common-components';

import { getTermsDialogStatus, actions } from '@dragonfruit/redux/termsDialog';
import { getRegion } from '@dragonfruit/redux/profile';
import { getLocaleCode } from '@dragonfruit/redux/locale';

import { SUPPORTED_REGION_LOCALE_LIST } from '@snapask/common-components/dist/constants/locales';

const TERMS = 'terms';
const PRIVACY = 'privacy';
const mapStateToProps = state => ({
  isTermsDialogVisible: getTermsDialogStatus(state),
  region: getRegion(state),
  currentLocale: getLocaleCode(state),
});

class TermsDialogHandler extends Component {
  static propTypes = {
    agreeNewTerms: func.isRequired,
    currentLocale: string.isRequired,
    declineNewTerms: func.isRequired,
    hideTermsDialog: func.isRequired,
    isTermsDialogVisible: bool.isRequired,
    t: func.isRequired,
    region: string,
  };

  static contextTypes = {
    router: shape({
      history: object.isRequired,
    }),
  };

  static defaultProp = {
    region: '',
  };

  render() {
    const {
      hideTermsDialog,
      isTermsDialogVisible,
      declineNewTerms,
      t,
      region: userRegion,
      agreeNewTerms,
      currentLocale,
    } = this.props;

    const userRegionLocale = SUPPORTED_REGION_LOCALE_LIST[userRegion];

    const { router: { history } = {} } = this.context;
    const currentPathName = history.location.pathname;
    const isTermsOrPrivacy =
      currentPathName.includes(TERMS) || currentPathName.includes(PRIVACY);
    const showTermsDialog =
      userRegionLocale && !isTermsOrPrivacy && isTermsDialogVisible;

    if (!showTermsDialog) {
      return null;
    }

    return (
      <PrivacyAndTermsDialog
        onAgree={agreeNewTerms}
        onDecline={declineNewTerms}
        onModalClose={hideTermsDialog}
        currentLocale={currentLocale}
        t={t}
      />
    );
  }
}

export default compose(
  translate(['terms', 'footer']),
  connect(mapStateToProps, {
    hideTermsDialog: actions.hideTermsDialog,
    agreeNewTerms: actions.agreeNewTerms,
    declineNewTerms: actions.declineNewTerms,
  })
)(TermsDialogHandler);



// WEBPACK FOOTER //
// ./app/containers/TermsDialogHandler/TermsDialogHandler.jsx